import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getWithdrawAvailableDates: () => ({
    url: `Tbs/api/v1/User/Remain`,
    method: 'GET',
  }),
  getWithdrawAvailableDatesV2: () => ({
    url: `Tbs/api/v2/User/Remain`,
    method: 'GET',
  }),
  getAllBanks: (input) => ({
    url: `Tbs/api/v1/Baseinfo/Banks/${input?.search || ''}`,
    method: 'GET',
  }),
  getMyBankAccounts: (input) => ({
    url: `Tbs/api/v1/User/BankAccount/Me`,
    method: 'GET',
    params: input,
  }),
  addBankAccount: (input) => ({
    url: `Tbs/api/v1/User/CashFlow/Account`,
    method: 'POST',
    data: input,
  }),
  getWithdrawsHistory: (input) => ({
    url: `Tbs/api/v1/User/Report/Withdrawal`,
    method: 'POST',
    data: input,
  }),
  getDepositsHistory: (input) => ({
    url: `Tbs/api/v1/User/Report/Deposit`,
    method: 'POST',
    data: input,
  }),
  getTransactionsHistory: (input) => ({
    url: `Tbs/api/v1/User/AccountHistory/Me`,
    method: 'POST',
    data: input,
  }),
  getHamiProfitHistory: (input) => ({
    url: `Tbs/api/v1/User/HamiProfit/Me`,
    method: 'POST',
    data: input,
  }),
  cancelWithdraw: (input) => ({
    url: `Tbs/api/v1/User/CashFlow/${input.cashFlowRequestId}`,
    method: 'DELETE',
  }),
  submitWithdraw: (input) => ({
    url: `Tbs/api/v1/User/CashFlow`,
    method: 'POST',
    data: input,
  }),
  getUserRemainForWallet: () => ({
    url: `Tbs/api/v1/User/RemainForWallet`,
    method: 'GET',
  }),
  getReceiptBankAccounts: () => ({
    url: `Tbs/api/v1/Receipt/BankAccounts`,
    method: 'GET',
  }),
  submitReceipt: (input) => ({
    url: `Tbs/api/v1/Receipt`,
    method: 'POST',
    data: input,
  }),
  getReceiptHistory: (input) => ({
    url: `Tbs/api/v1/Receipt/History`,
    method: 'POST',
    data: input,
  }),
  getChildrenList: () => ({
    url: `Tbs/api/v1/User/ChildrenInformation`,
    method: 'GET',
  }),
  depositToChild: (input) => ({
    url: `Tbs/api/v1/User/CashFlowParentToChildTransfer`,
    method: 'Post',
    data: input,
  }),
  getChildrenInformationWithBalance: () => ({
    url: `Tbs/api/v1/User/ChildrenInformationWithBalance`,
    method: 'GET',
  }),
};

export default apis;
